import { Control, Controller, FieldError, FieldValues, Path } from "react-hook-form";
import { TextField, FormHelperText } from "@mui/material";

interface InputTextAreaProps<K extends FieldValues> {
  name: Path<K>;
  control: Control<K>;
  error?: FieldError;
  value?: string;
  desabilitado?: boolean;
  readonly?: boolean;
  label?: string;
}

export default function InputTextArea<K extends FieldValues>({
  name,
  control,
  error,
  desabilitado,
  readonly,
  label,
}: InputTextAreaProps<K>) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <>
          <TextField
            {...field}
            value={field.value ?? ""}
            onChange={(val) => field.onChange(val.target.value)}
            disabled={desabilitado}
            autoComplete="off"
            multiline
            rows={4} // Se puede ajustar según la necesidad
            slotProps={{
              htmlInput: {
                readOnly: readonly,
              },
            }}
            margin="dense"
            label={label}
            fullWidth
            variant="standard"
            error={!!error}
          />
          {error && <FormHelperText error>{error.message}</FormHelperText>}
        </>
      )}
    />
  );
}
